import { createActionGroup, props, emptyProps } from '@ngrx/store';

import { FeatureFlagContext, FeatureFlagStateModel } from './feature-flag-state.model';

export const FeatureFlagActions = createActionGroup({
  source: 'Feature Flags',
  events: {
    'Init Launch Darkly': emptyProps(),
    'Close Launch Darkly Connection': emptyProps(),
    'Update Launch Darkly User': emptyProps(),
    // On sign-out, re-point LD at a fresh anonymous context. Without it the client stays pinned to
    // the signed-out user's identified context (`identify()` is never undone, `init()` is
    // idempotent), so every logged-out flag read — the login-screen launcher included — is stale.
    'Re Anonymize Launch Darkly': emptyProps(),
    // Records which context produced each flag set. Anonymous updates must not satisfy guards waiting
    // on the identified set.
    'Initial Flags Received': props<{ flags: FeatureFlagStateModel; context: FeatureFlagContext }>(),
    'Updated Flags Received': props<{ newFlags: FeatureFlagStateModel; context: FeatureFlagContext }>(),
    'Process Flag Updates': props<{
      oldFlags: FeatureFlagStateModel;
      newFlags: FeatureFlagStateModel;
      context: FeatureFlagContext;
    }>(),
    'Updated Flags Processed': props<{ flags: FeatureFlagStateModel; context: FeatureFlagContext }>(),
    'Update Feature Flag': props<{ key: string; value: boolean }>(),
    'Refresh App': emptyProps(),
  },
});
